export default [{
	path: 'org',
	component: () => import('../../sys/system/org/index'),
	redirect: '/sys/org/school',
	children: [{
			path: 'school',
			component: () => import('../../sys/system/org/school'),
			meta: {
				title: '（学校管理）后台管理'
			}
		},
		{
			path: 'dept',
			component: () => import('../../sys/system/org/dept'),
			meta: {
				title: '（学院管理）后台管理'
			}
		},
		{
			path: 'major',
			component: () => import('../../sys/system/org/major'),
			meta: {
				title: '（专业管理）后台管理'
			}
		},
		{
			path: 'class',
			component: () => import('../../sys/system/org/class'),
			meta: {
				title: '（班级管理）后台管理'
			}
		},
	]
}]